import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
  icons: {
    iconfont: 'mdi' // default - only for display purposes
  },
  theme: {
    themes: {
      light: {
        primary: '#f1aa21',
        secondary: '#4fb9dd',
        accent: '#bdbdbd',
        error: '#EF1A1A',
        info: '#ffdb58',
        success: '#4CAF50',
        warning: '#6ff9ff'
      }
    }
  }
})
